import SecureBaseModel from './SecureBaseModel';

class NCSModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static NCS_SUBSCRIPTION = 'ncs-subscription';
    static NCS_OTHER_SUBSCRIPTION = 'ncs-other-subscription';
    static NCS_SUBSCRIPTION_RECORD = 'ncs-subscription-record';
    static NCS_CURRENT_SUBSCRIPTION = 'ncs-current-subscription';
    static NCS_COUNT_PREVIOUS_ITEM_SUBSCRIPTIONS = 'ncs-past-item-subscriptions';
    static NCS_PREVOUS_ITEM_SUBSCRIPTIONS = 'ncs-previous-item-subscriptions';
    static NCS_PREVOUS_ANY_ITEM_SUBSCRIPTIONS = 'ncs-previous-any-item-subscriptions';
    static NCS_SUBSCRIPTIONS = 'ncs-subscriptions';
    static NCS_ITEM_INFO = 'ncs-item-info';
    static NCS_ITEMS_INFO = 'ncs-items-info';
    static NCS_TRANSACTIONS = 'ncs-transactions';
    static NCS_DATE_EXPIRED = 'ncs-date-expired';
    static NCS_ACTIVE_FREE_MONTH = 'ncs-active-free-month';
    static NCS_RECEIPT_ITEM_INFO = 'ncs-receipt-item-info';
    static NCS_RECEIPT_INFO = 'ncs-retrieve-receipt';
    static UPDATE_RECEIPT_STATUS = 'ncs-update-receipt-status';
    static NCS_NEW_ORDER_ID = 'ncs-new-order-id';

    constructor() {
        super();
    }

    // params { custId: value, itemId: value }
    async getUserSubscription(params) {
        return await this.postData(NCSModel.NCS_SUBSCRIPTION, params);
    }

    // params { custId: value }
    async getOtherSubscription(params) {
        return await this.postData(NCSModel.NCS_OTHER_SUBSCRIPTION, params);
    }

    // params { custId: value, itemId: value }
    async getUserSubscriptionRecord(params) {
        return await this.postData(NCSModel.NCS_SUBSCRIPTION_RECORD, params);
    }

    // params { custId: value }
    async getCurrentSubscription(params) {
        return await this.postData(NCSModel.NCS_CURRENT_SUBSCRIPTION, params);
    }

    // params { custId: value }
    async countPreviousItemSubscriptions(params) {
        return await this.postData(NCSModel.NCS_COUNT_PREVIOUS_ITEM_SUBSCRIPTIONS, params);
    }

    // params { custId: value }
    async getPreviousItemSubscriptions(params) {
        return await this.postData(NCSModel.NCS_PREVOUS_ITEM_SUBSCRIPTIONS, params);
    }

    // params { custId: value }
    async getPreviousAnyItemSubscriptions(params) {
        return await this.postData(NCSModel.NCS_PREVOUS_ANY_ITEM_SUBSCRIPTIONS, params);
    }

    // params { custId: value }
    async getAllSubscriptionStatus(params) {
        return await this.postData(NCSModel.NCS_SUBSCRIPTIONS, params);
    }

    // params { itemId: value }
    async getItemInfo(params) {
        return await this.postData(NCSModel.NCS_ITEM_INFO, params);
    }

    async getItemsInfo() {
        return await this.getData(NCSModel.NCS_ITEMS_INFO, {});
    }

    // params { custId: value, itemId: value }
    async getItemTransactionHistory(params) {
        return await this.postData(NCSModel.NCS_TRANSACTIONS, params);
    }

    // params { date: value }
    async dateExpired(params) {
        return await this.postData(NCSModel.NCS_DATE_EXPIRED, params);
    }

    // params { custId: value }
    async activeFreeMonth(params) {
        return await this.postData(NCSModel.NCS_ACTIVE_FREE_MONTH, params);
    }

    // params { custId: value, orderId: value  }
    async getReceiptItemInfo(params) {
        return await this.postData(NCSModel.NCS_RECEIPT_ITEM_INFO, params);
    }

    // params { orderNo: value, paymentLogSeq: value  }
    async getReceiptInfo(params) {
        return await this.postData(NCSModel.NCS_RECEIPT_INFO, params);
    }

    // params { orderNo: value, paymentLogSeq: value  }
    async updateReceiptStatus(params) {
        return await this.postData(NCSModel.UPDATE_RECEIPT_STATUS, params);

    }

    async getNewOrderId() {
        return await this.getData(NCSModel.NCS_NEW_ORDER_ID, {});
    }
}

export default NCSModel;
